var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 228,
    viewBox: "0 0 200 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.4323 223.41C99.8102 228.829 111.353 228.815 120.703 223.368L140.612 211.785L69.7645 170.842C48.3515 158.471 35.1634 135.6 35.1634 110.843V28.916L15.1705 40.4008C5.79262 45.7913 0 55.7982 0 66.6214V130.927C0 155.811 13.2583 178.809 34.7838 191.25L90.4183 223.396L90.4323 223.41Z",
    fill: "url(#paint0_linear_169_308)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.513 7.32574C105.294 12.4348 97.0266 22.892 94.9458 35.4605C94.6224 37.4591 94.4396 39.4999 94.4396 41.5829V96.2479C94.4396 102.539 96.1408 108.591 99.1777 113.855C102.201 119.119 106.601 123.595 112.042 126.733L128.914 136.459C137.406 141.356 147.262 144.157 157.765 144.157C174.411 144.157 189.427 137.134 200 125.889V157.331C200 163.594 198.327 169.604 195.318 174.84C192.281 180.117 187.895 184.607 182.44 187.76C171.585 194.037 158.201 194.037 147.346 187.76L111.339 166.958L85.1461 151.814C69.1602 142.581 59.3184 125.495 59.3184 107.029V35.1509C59.3184 28.8737 60.9915 22.8217 64.0143 17.5719C67.0372 12.3081 71.4238 7.84649 76.8509 4.7079C87.7331 -1.5693 101.104 -1.5693 111.958 4.7079L116.513 7.33981V7.32574Z",
    fill: "url(#paint1_linear_169_308)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.158 40.6539C190.144 49.8867 200 66.9589 200 85.4387V85.495C200 108.31 182.158 127.479 159.381 128.337C155.051 128.492 150.861 128 146.896 126.944C157.357 121.061 164.85 109.956 164.85 96.2337C164.85 86.9587 161.223 78.2185 154.952 71.7302C152.717 69.4079 150.144 67.3812 147.262 65.7204L110.2 44.2991V41.6813C110.2 29.5491 120.014 19.7393 132.119 19.7393C135.845 19.7393 139.36 20.6682 142.425 22.3149L174.158 40.6539Z",
    fill: "url(#paint2_linear_169_308)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_308",
    x1: -4.14762,
    y1: 51.5758,
    x2: 101.536,
    y2: 234.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_308",
    x1: 65.111,
    y1: 11.4918,
    x2: 170.865,
    y2: 194.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_308",
    x1: 127.241,
    y1: 19.1622,
    x2: 185.004,
    y2: 119.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#717171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGray);
export default __webpack_public_path__ + "static/media/logo-gray.2c2ec65ece79e757abe5b0d902f73f97.svg";
export { ForwardRef as ReactComponent };